import { userKey } from 'queryKeys';

const FAVORITE_FILTERS = 'favorite-filters';

export const favoriteFiltersQuery = userKey.query(FAVORITE_FILTERS);
